<template>
<v-form ref="form" v-model="valid">
  <v-container fluid>
     <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>
  
    <v-card-title>General</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>Tank Water Level Console S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="serialNumber"
            item-value="_id"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="waterTank[0].waterTankSn"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Tank Water Level Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="waterTank[0].waterTankConsole"> </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
        <v-subheader>Location Name</v-subheader>
        </v-col>
      <v-col cols="2">
           <v-select  
            :items="locationItem"
            item-value="_id"
            :item-text="
            (locationItem) => {
            return (locationItem.location);
            }"
            v-model="waterTank[0].location"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>Console Power Source</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="waterTank[0].boardName"> </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>Tank Water Level Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="waterTank[0].waterTankSensor"> </v-text-field>
        </v-col>
      </v-row>
     <v-row>
        <v-col cols="2">
          <v-subheader>Tank Water Level Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="serialNumber"
            item-value="_id"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="waterTank[0].waterTankSensorSn"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Remarks</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="waterTank[0].locationRemarks"> </v-text-field>
        </v-col>
      </v-row>
   </v-card>

     <v-btn fixed dark fab bottom right color="blue" @click="saveItem()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
  </v-container>
</v-form>
</template>


<script>
import axios from "axios";
import router from "../../router";

export default {
  data() {
    return {
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: 'Water Level Tank',
          disabled: false,
          href: '/water-tank',
        },
        {
          text: 'Details',
          disabled: false,
          href: '/water-tank/details/'+this.$route.params.id,
        },
        {
          text: 'Edit',
          disabled: true,
          href: '',
        },
      ],
    waterTank: [],
    waterTankAll: [],

    valid: true,
    serialNumber: [],
    locationItem: [], 
    showDeleteDialog: false,
    };
  },
  created(){
      this.loadsSerialNumber();
      this.loadsLocation();
      this.loadsWaterTank();
      this.loadsWaterTankAll();
  },
  methods: {
    loadsWaterTank: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/water-tank/"+ this.$route.params.id;
    axios.get(apiURL).then(res => {
    this.waterTank = res.data;
    }).catch(error => {
        console.log(error)
    });
    },
    loadsWaterTankAll: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/water-tank-all/"+ this.$route.params.id;
    axios.get(apiURL).then(res => {
    this.waterTankAll = res.data;
    }).catch(error => {
        console.log(error)
    });
    },
    loadsLocation: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/location";
    axios.get(apiURL).then(res => {
    this.locationItem = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    loadsSerialNumber: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/serial-number-available";
    axios.get(apiURL).then(res => {
    this.serialNumber = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    async saveItem() {
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + "/api/update-water-tank/" + this.$route.params.id;
      axios
        .post(
      apiURL,
          {
    waterTankSn: this.waterTank[0].waterTankSn,
    waterTankConsole: this.waterTank[0].waterTankConsole,
    boardName: this.waterTank[0].boardName,
    location: this.waterTank[0].location,
    waterTankSensorSn: this.waterTank[0].waterTankSensorSn,
    waterTankSensor: this.waterTank[0].waterTankSensor,
    locationRemarks: this.waterTank[0].locationRemarks,
    modifiedBy: this.$keycloak.tokenParsed.given_name
          });
    }
     router.go(-1);
      }
    }
  };
</script>